import { lazy } from 'react';

const SalesPage = lazy(() => import('../pages/Sales.page'));
const AddSalePage = lazy(() => import('../pages/AddSale.page'));

const SalesRoutes = [
    {
        path: '/sales',
        element: <SalesPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/sales/add',
        element: <AddSalePage />,
        layout: 'default',
        isAuthReq: true,
    },
];
export { SalesRoutes };
